import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { OGLAttribution } from '../components/OGLAttribution';
import { EnvelopeSimple, Phone, ArrowLeft } from '@phosphor-icons/react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_compliance-hub-623/artifacts/04kw0jh0_IMG_4683.jpeg';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-muted/30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center space-x-2">
            <img src={LOGO_URL} alt="Vantage" className="h-12 w-auto" />
            <span className="text-xl font-bold tracking-tight">Vantage Fleet</span>
          </Link>
        </div>

        {/* Contact Card */}
        <div className="border border-border bg-background">
          <div className="p-8 border-b border-border">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-2">Contact Us</h1>
            <p className="text-muted-foreground">Get in touch with the Vantage Fleet & Compliance team</p>
          </div>

          <div className="p-8 space-y-8">
            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 flex items-center justify-center bg-primary/10 rounded-sm flex-shrink-0">
                <EnvelopeSimple weight="duotone" className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold mb-1">Email</h3>
                <a 
                  href="mailto:info@vantagefleet.co.uk" 
                  className="text-primary hover:underline text-lg"
                  data-testid="contact-email-link"
                >
                  info@vantagefleet.co.uk
                </a>
                <p className="text-sm text-muted-foreground mt-1">We aim to respond within 24 hours</p>
              </div>
            </div>

            {/* Info */}
            <div className="p-6 bg-muted/50 border border-border">
              <h3 className="font-semibold mb-2">About Vantage Fleet & Compliance</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Vantage Fleet & Compliance provides the complete searchable reference to the DVSA Enforcement 
                Sanctions Policy (May 2026). Built for transport managers, fleet operators, and compliance 
                professionals across the UK.
              </p>
              <div className="mt-4 pt-4 border-t border-border">
                <OGLAttribution />
              </div>
            </div>

            {/* Corporate CTA */}
            <div className="p-6 border border-border">
              <h3 className="font-semibold mb-2">Corporate Accounts</h3>
              <p className="text-muted-foreground text-sm mb-4">
                Need multiple user access for your organisation? Submit a corporate enquiry for bespoke pricing.
              </p>
              <Link to="/corporate">
                <Button className="rounded-sm" data-testid="corporate-cta-btn">
                  Corporate Enquiries
                  <ArrowLeft weight="bold" className="ml-2 h-4 w-4 rotate-180" />
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Back */}
        <div className="mt-6 text-center">
          <Link to="/">
            <Button variant="ghost" className="rounded-sm" data-testid="back-home-btn">
              <ArrowLeft weight="bold" className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
